import { orchestrator } from 'satcheljs';
import {
    finishPanning,
    panByWheel,
    panDown,
    panLeft,
    panRight,
    panUp,
    resetPanAndZoom,
    zoomByWheel,
    zoomIn,
    zoomOut,
} from '../actions';
import { getSelectedProjectId, setProjectInLocalStorage } from 'owa-timestream-store';
import getStore from '../store';

[
    finishPanning,
    panByWheel,
    panDown,
    panLeft,
    panRight,
    panUp,
    resetPanAndZoom,
    zoomByWheel,
    zoomIn,
    zoomOut,
].forEach(action => orchestrator(action, setPanAndZoomInLocalStorage));

function setPanAndZoomInLocalStorage() {
    const projectId = getSelectedProjectId();
    const { pan, zoom } = getStore();
    setProjectInLocalStorage(projectId, { pan, zoom });
}
